const paymentCurrencies: string[] = ['RUB', 'USD', 'EUR', 'USDT', 'PLN', 'UAH', 'INR', 'KZT', 'UZS', 'MXN', 'CZK', 'BRL', 'VND', 'AUD', 'ARS'];
export default paymentCurrencies;
